"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetVehicles = exports.deleteManyVehicles = exports.deletedOneVehicle = exports.updatedManyVehicles = exports.updatedOneVehicle = exports.gotManyVehicles = exports.gotOneVehicle = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOneVehicle = gotOne;
exports.gotManyVehicles = gotMany;
exports.updatedOneVehicle = updatedOne;
exports.updatedManyVehicles = updatedMany;
exports.deletedOneVehicle = deletedOne;
exports.deleteManyVehicles = deleteMany;
exports.resetVehicles = reset;
//# sourceMappingURL=actions.js.map